import _tmpl from "./customDataTable.html";
import { registerComponent as _registerComponent } from "lwc";
import LightningDatatable from 'lightning/datatable';
import helpTextTemplate from './helpTextTemplate.html';
import formattedUrlTemplate from './formattedUrlTemplate.html';
import validationStatusDisplayTemplate from './validationStatusDisplayTemplate.html';
import queuedNameTemplate from './queuedNameTemplate.html';
class customDatatable extends LightningDatatable {}
customDatatable.customTypes = {
  helpTextDisplay: {
    template: helpTextTemplate,
    standardCellLayout: true,
    typeAttributes: ['label', 'tooltip']
  },
  formattedUrl: {
    template: formattedUrlTemplate,
    standardCellLayout: true,
    typeAttributes: ['label', 'data', 'name', 'developerName']
  },
  validationStatusDisplay: {
    template: validationStatusDisplayTemplate,
    standardCellLayout: true,
    typeAttributes: ['message', 'validationType', 'isError', 'validationTooltipMessages']
  },
  queuedName: {
    template: queuedNameTemplate,
    standardCellLayout: true,
    typeAttributes: ['name', 'developerName', 'type', 'modifiedOn', 'modifiedBy']
  }
};
export default _registerComponent(customDatatable, {
  tmpl: _tmpl
});